import type { IconData } from '@stacksjs/iconify-core'

export const spaceBar: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M40 288v128h424V288h-32v96H72v-96z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default spaceBar
